<script context="module" lang="ts">
	import shopify from '$lib/api/ecom/shopify';
	import type {
		CollectionInterfaceItem,
		ProductInterfaceItem
	} from '$lib/types/ecom/interfaceTypes';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export async function load(data: Props, params: any, additionalLoadData: any = {}) {

		const productsList = JSON.parse(data.products) as ProductInterfaceItem[] | undefined;

		let products = (
			await shopify.getProductsById(
				productsList
					?.map((item) => item.selectedProduct?.node?.id)
					.filter((item): item is string => !!item) ?? [],
				additionalLoadData.data.location,
				params.lang
			)
		).nodes;

		return {
			products
		};
	}

	export const config: SectionConfig = {
		collection: 'section_tiny_product_teaser',
		availableFor: ['pages'],
		query: gql`
			products
    `,
		load
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		products: string;
	};
</script>

<script lang="ts">
	import ProductCard from '$lib/components/ecom/ProductCard.svelte';
	import Section from '$lib/components/layout/Section.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
	export let additionalData: Awaited<ReturnType<typeof load>>;
</script>

<!-- TODO: add support for preselected variants with custom type -->

<Section class="section-tiny-product-teaser">
	<div class="wrapper">
		<div class="products">
			{#each additionalData.products ?? [] as product}
				<div class="product-wrapper">
					<ProductCard {product} />
				</div>
			{/each}
		</div>
	</div>
</Section>

<style lang="scss">
	.wrapper {
		display: flex;
		justify-content: center;

		.products {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: v(content-gap-lg);
			max-width: 500px;
		}
	}
</style>
